
import React from "react";
import { Dialog, DialogContent, DialogHeader } from "@/components/ui/dialog";
import { useTheme } from "@/lib/theme/ThemeContext";
import { Database } from "@/types/supabase";
import { useEditChildForm } from "./hooks/useEditChildForm";
import { EditChildForm } from "./EditChildForm";
import { EditChildDialogHeader } from "./EditChildDialogHeader";
import { EditChildDialogFooter } from "./EditChildDialogFooter";

type Child = Database["public"]["Tables"]["children"]["Row"];

export interface EditChildDialogProps {
  open: boolean;
  onOpenChange: (open: boolean) => void;
  selectedChild: Child | null;
  onSave: (updatedChild: Child) => void;
}

export function EditChildDialog({ 
  open, 
  onOpenChange, 
  selectedChild, 
  onSave 
}: EditChildDialogProps) {
  const isLightTheme = false;
  
  const {
    name,
    setName,
    dateOfBirth,
    setDateOfBirth,
    isSubmitting,
    handleSave,
    resetForm
  } = useEditChildForm(selectedChild, onSave);

  const handleCancel = () => {
    resetForm();
    onOpenChange(false);
  };

  const handleSubmitSave = () => {
    handleSave();
    onOpenChange(false);
  };

  return (
    <Dialog open={open} onOpenChange={handleCancel}>
      <DialogContent className={isLightTheme 
        ? "bg-white border-slate-200" 
        : "bg-slate-900 border-slate-700"
      }>
        <DialogHeader>
          <EditChildDialogHeader />
        </DialogHeader>

        <EditChildForm
          name={name}
          setName={setName}
          dateOfBirth={dateOfBirth}
          setDateOfBirth={setDateOfBirth}
        />

        <EditChildDialogFooter
          onCancel={handleCancel}
          onSave={handleSubmitSave}
          isSubmitting={isSubmitting}
          isDisabled={!name || !dateOfBirth}
        />
      </DialogContent>
    </Dialog>
  );
}
